import { useEffect, useRef } from "react";
import { MessageContext } from "./context";
import type { MessageStore, MessageStoreState } from "./store";
import { createMessageStore } from "./store";

type MessageProviderProps = React.PropsWithChildren<MessageStoreState>;

const MessageProvider: React.FC<MessageProviderProps> = (props) => {
	const { children, ...ctxValue } = props;
	const messageStoreRef = useRef<MessageStore | null>(null);
	if (!messageStoreRef.current) {
		messageStoreRef.current = createMessageStore(ctxValue);
	}
	useEffect(() => {
		if (ctxValue.search && messageStoreRef.current) {
			messageStoreRef.current.setState({ search: ctxValue.search });
		}
	}, [ctxValue.search]);
	return (
		<MessageContext.Provider value={messageStoreRef.current}>
			{children}
		</MessageContext.Provider>
	);
};

export default MessageProvider;
